import { render } from "./RehabilitationTermComponent.vue?vue&type=template&id=8cfbb43c&scoped=true&ts=true"
import script from "./RehabilitationTermComponent.vue?vue&type=script&lang=ts"
export * from "./RehabilitationTermComponent.vue?vue&type=script&lang=ts"

import "./RehabilitationTermComponent.vue?vue&type=style&index=0&id=8cfbb43c&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1696261099/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8cfbb43c"]])

export default __exports__